import React, { createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, TextField, CircularProgress, InputAdornment } from '@material-ui/core';

class FHETextField extends PureComponent {
    textInput = createRef();

    static propTypes = {
        disabled: PropTypes.bool,
        loading: PropTypes.bool,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
        helperText: PropTypes.string,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        name: PropTypes.string,
        suffix: PropTypes.string,
        className: PropTypes.string,
        rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        margin: PropTypes.string,
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        fullWidth: PropTypes.bool,
        multiline: PropTypes.bool,
        autoComplete: PropTypes.string,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        inputProps: PropTypes.object,
        InputProps: PropTypes.object,
        InputLabelProps: PropTypes.object,
        FormHelperTextProps: PropTypes.object,
        rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        disabled: false,
        fullWidth: true,
        multiline: false,
        loading: false,
        margin: 'normal',
        type: 'string',
        placeholder: '',
        value: '',
        helperText: '',
        name: '',
        label: null,
        error: null,
        rows: null,
        suffix: null,
        rowsMax: null,
        onChange: null,
        onBlur: null,
        onFocus: null,
        inputProps: {},
        InputProps: { disableUnderline: false },
        InputLabelProps: { shrink: true },
        FormHelperTextProps: { component: 'div' },
        className: '',
        autoComplete: 'on'
    };

    focus = () => {
        this.textInput.current.focus();
    };

    render() {
        let {
            suffix,
            disabled,
            type,
            value,
            label,
            helperText,
            name,
            error,
            onChange,
            inputProps,
            InputProps,
            InputLabelProps,
            fullWidth,
            margin,
            placeholder,
            FormHelperTextProps,
            className,
            autoComplete,
            onBlur,
            onFocus,
            multiline,
            rowsMax,
            rows,
            classes,
            loading
        } = this.props;

        if (value === null) value = '';

        let newInputProps = InputProps;
        if (InputProps.endAdornment) {
            newInputProps = { ...InputProps, classes: { underline: type !== 'number' && classes.underline } };
        }
        if (suffix) newInputProps = { ...InputProps, endAdornment: <InputAdornment className={classes.InputAdornment}>{suffix}</InputAdornment> };

        if (loading)
            return (
                <div className={classes.loadingContainer}>
                    <CircularProgress />
                </div>
            );
        return (
            <TextField
                className={`${classes.FHETextField} ${className}`}
                disabled={disabled}
                fullWidth={fullWidth}
                type={type}
                value={value}
                label={label}
                helperText={error || helperText}
                placeholder={placeholder}
                name={name}
                error={!!error}
                onChange={onChange}
                inputProps={inputProps}
                InputProps={newInputProps}
                InputLabelProps={InputLabelProps}
                margin={margin}
                FormHelperTextProps={FormHelperTextProps}
                autoComplete={autoComplete}
                onBlur={onBlur}
                onFocus={onFocus}
                multiline={multiline}
                rowsMax={rowsMax}
                rows={rows}
                inputRef={this.textInput}
            />
        );
    }
}

const styles = () => ({
    underline: {
        '&:before': {
            marginRight: 50
        },
        '&:after': {
            marginRight: 50
        }
    },
    FHETextField: {
        flex: 1,
        top: -5
    },
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    InputAdornment: {
        top: 'calc(50%)',
        right: 20,
        position: 'absolute'
    }
});

export default withStyles(styles, { withTheme: true })(FHETextField);



// WEBPACK FOOTER //
// ./data/components/FHETextField.js